import React from 'react';
export const Misc = {
    'dot_03_m': (props) => (React.createElement("svg", { className: props === null || props === void 0 ? void 0 : props.className, width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M4 8C1.79086 8 0 6.20914 0 4C0 1.79086 1.79086 0 4 0C6.20914 0 8 1.79086 8 4C8 5.06087 7.57857 6.07828 6.82843 6.82843C6.07828 7.57857 5.06087 8 4 8Z", fill: "#18181F" })))
};
//# sourceMappingURL=misc.js.map